import React, { FC } from 'react';
import cx from 'classnames';
import { CardLinkProps } from '@/helpers/CardControls/typings';
import useThemeBlock from '@/hooks/useThemeBlock';
import { Link } from '@/helpers/Link/render';
import block from './block.json';
// styles
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
type CardFeatureProps = ThemeProps & {
	text: string;
	link?: CardLinkProps;
};

/**
 * COMPONENT
 */
export const CardFeature: FC<CardFeatureProps> & BlockConfigs = ({
	text,
	link: { href = null, opensInNewTab = false, ...linkProps } = {},
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(block.slug, theme);

	const rootClass = cx(
		'supt-card supt-cardFeature',
		getStyles(blockTheme),
		href && 'supt-withLink'
	);

	const htmlProps = {
		'data-variant': variant,
	};

	return (
		<div className={rootClass} data-block={block.slug} {...htmlProps}>
			{href ? (
				<Link
					href={href}
					className="supt-cardFeature__text supt-cardFeature__link"
					{...(opensInNewTab && {
						target: '_blank',
						rel: 'noopener noreferrer',
					})}
					dangerouslySetInnerHTML={{ __html: text }}
					{...linkProps}
				/>
			) : (
				<p
					className="supt-cardFeature__text"
					dangerouslySetInnerHTML={{ __html: text }}
				/>
			)}
		</div>
	);
};

CardFeature.slug = block.slug;
CardFeature.title = block.title;
